export const ICON_AND_TEXT = 'ICON_AND_TEXT';
export const TEXT_ONLY = 'TEXT_ONLY';
export const ICON_ONLY = 'ICON_ONLY';

export const SQUARE = 'SQUARE';
export const LOZENGE = 'LOZENGE';

export const SMALL = 'SMALL';
export const MEDIUM = 'MEDIUM';
export const LARGE = 'LARGE';

export const LEFT = 'LEFT';
export const RIGHT = 'RIGHT';



// WEBPACK FOOTER //
// ./components/button/constants.js